<template>
    <template v-if="room.Pax.SpecialRequest">
        <div class="room-special-request">
            <Translation
                class="room-special-request-headline"
                :translate="{ key: 'shared.special_request_headline' }" />
            <div class="room-special-request-description">
                {{ room.Pax.SpecialRequest }}
            </div>
        </div>
        <Notification variant="neutral" padding="l" :tier="2">
            <Translation :translate="{ key: 'shared.special_request_no_guarantee' }" />
        </Notification>
    </template>
</template>
<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { Room } from '@/api/Cart/cart.interfaces';
    import Translation from '@ui/components/Translation/Translation.vue';
    import Notification from '@ui/components/Notification/Notification.vue';
    export default defineComponent({
        name: 'SpecialRequest',
        components: { Notification, Translation },

        props: {
            room: {
                type: Object as PropType<Room>,
                required: true,
            },
        },
    });
</script>

<style scoped lang="scss">
    @forward 'SpecialRequest';
</style>
